
const React = require('react')

const products = [
    {
        "title": "mill choclkate",
        "style": "bar",
        "sku": "11"
    },
    {
        "title": "dark choclkate",
        "style": "bar",
        "sku": "12"
    },
    {
        "title": "galaxy choclkate",
        "style": "bar",
        "sku": "13"
    }
]


let dataProfile = {
    spaceKey: "10000297@4@F@10@10@20251124@7@Y@SVR"
}

const withCustomerSpacesHOC = C => {
    //Step 1 C  define inline
    class WithCustomerSpacesHOC extends React.Component {
      constructor(props){

        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(me)
    }

      state = {
        searchTerm: ""
      };
      handleSearch = event => {
        this.setState({ searchTerm: event.target.value });
      };
  
      getAppDetails(paramQSpaceId){
        console.log('order detail confirmationcode**************', paramQSpaceId)
       // this.props.loadOrderderNow(paramQSpaceId)
        // this.props.getSoDetails("mancreek")
 
       // this.props.ordAndImagesSV()
        
     }
     componentWillMount()	{
        console.log('!!!!!!!!sv--task=--- link sends us params')
        let id;
        if(this.props.svparams){
           id = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }
       
   console.log('!!!!!!!!!!!!!!!!sbv--HOC  C gets customerId  ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
   
   
      this.getAppDetails(id)
     }

      render() {
       
        let id;
        let svcustProfile = {
          customerId: -11
      }
        if(this.props.svparams){
          svcustProfile.customerId = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         svcustProfile.customerId = -11;
        }
        let { searchTerm } = this.state;
        let filteredProducts = filterProducts(searchTerm);
       

       console.log('sv%%%svcustProfile withCustomerSpacesHOC', svcustProfile)
        
        return (
          <div>
            {/*
             <input
              onChange={this.handleSearch}
              value={searchTerm}
              type="text"
              placeholder="Search"
            />
            */}
           
            <C svcustProfile={svcustProfile} dataProfile={dataProfile}  />
          </div>
        );
      }
    };
    //Step 2 retuen C
    WithCustomerSpacesHOC.displayName = `WithCustomerSpacesHOC(${getDisplayName(C)})`;
    return WithCustomerSpacesHOC;
  };
  
  const getDisplayName = (C) => {
    return C.displayName || C.name || 'Component';
  }


  const filterProducts = (searchTerm) => {
    searchTerm = searchTerm.toUpperCase()
    return products.filter(product => {
      let str = `${product.title} ${product.style} ${product.sku}`.toUpperCase();
      return str.indexOf(searchTerm) >= 0;
    })
  }


  export default withCustomerSpacesHOC